import type { HTMLAttributes } from "react";
import { cn } from "../../lib/cn";

export type CardPadding = "sm" | "md" | "lg";
export type CardVariant = "default" | "hover";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: CardPadding;
  variant?: CardVariant;
}

const paddingClasses: Record<CardPadding, string> = {
  sm: "p-3",
  md: "p-4",
  lg: "p-6",
};

export function Card({
  padding = "md",
  variant = "default",
  className,
  children,
  ...rest
}: CardProps) {
  return (
    <div
      className={cn(
        "rounded-card border border-border bg-surface",
        variant === "hover" && "transition-colors duration-fast hover:bg-surface-hover",
        paddingClasses[padding],
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
